import { type FillDragEvent } from '../events/types.ts';
import { type SelectionState } from '../state/types.ts';

import { type ReducerResponse } from './types.ts';
import { calculateFillRange } from './utils/fill/calculate-fill-range.ts';

/**
 * Emits an axis-locked preview range while the fill handle is dragged. The
 * source selection remains authoritative and unchanged; no source is a noop.
 */
export function fillDragReducer(
  state: SelectionState,
  event: FillDragEvent
): ReducerResponse {
  const sourceRange = state.selections[state.selections.length - 1];

  if (!sourceRange) {
    return { next: state, delta: { kind: 'noop' } };
  }

  // Calculate the dashed-box bounds (enforcing horizontal/vertical axis lock)
  const fillRange = calculateFillRange(sourceRange, event.cell);

  return {
    next: {
      ...state,
      lastInteractionSource: event.source
    },
    delta: {
      kind: 'fillPreview',
      source: event.source,
      sourceRange,
      fillRange
    }
  };
}
